import { withDevtools } from "@angular-architects/ngrx-toolkit";
import { computed, effect, inject } from "@angular/core";
import { Environments } from "@mra/hlp9002";
import { getState, patchState, signalStore, withComputed, withHooks, withMethods, withState } from "@ngrx/signals";
import { InfosRequete } from "src/app/models/debugRequest";
import { environment } from "src/environments/environment";
import { LocalStorageService, StateKey } from "../shared/services/local-storage.service";
import { DebugState } from "./state";

function createDefaultState(): DebugState {
    return {
        modeDebug: false,
        requests: []
    };
}

// eslint-disable-next-line @typescript-eslint/typedef
export const debugStore = signalStore(
    { providedIn: "root" },

    withDevtools("debug"),

    withState(createDefaultState()),

    withComputed(({ modeDebug, requests }) => ({
        isModeDebugActivated: computed(() => {
            if (environment.type === Environments.P) {
                return false;
            }
            return modeDebug() ?? false;
        }),
        listRequests: computed(() => requests() ?? [])
    })),

    withMethods((store) => ({
        retrieveState(savedState: DebugState): void {
            patchState(store, () => savedState ?? createDefaultState());
        },

        setModeDebug(modeDebug: boolean): void {
            patchState(store, () => ({
                modeDebug
            }));
        },

        addDebugRequests(request: InfosRequete<any>): void {
            patchState(store, (state) => {
                const arr: InfosRequete<any>[] = Object.assign([], state.requests);
                arr.unshift(request);
                if (arr.length > 10) {
                    arr.pop();
                }
                return {
                    requests: arr
                };
            });
        },

        clearDebugRequest(): void {
            patchState(store, () => ({ requests: [] as InfosRequete<any>[] }));
        }
    })),

    withHooks((store) => {
        // eslint-disable-next-line @typescript-eslint/typedef
        const localStorageService = inject(LocalStorageService);

        return {
            onInit() {
                // eslint-disable-next-line @typescript-eslint/typedef
                const state = localStorageService.getSavedState<DebugState>(StateKey.DEBUG);
                if (state) store.retrieveState(state);
                effect(() => {
                    const state: DebugState = getState(store);
                    localStorageService.saveState(StateKey.DEBUG, state);
                });
            }
        };
    })
);
